<template lang="pug">
div
  h3.page-title {{$route.meta.title}}
  component(:is="formContainer.component ? formContainer.component : 'el-card'" v-loading="isLoading")
    div.card-head(slot="header")
      el-button(type="primary" @click="Submit") 保 存
      el-button(@click="$router.go(-1)") 取 消
    div.card-body
      component.form(v-for="(form,index) of forms" :is="form.wrapComponent? form.wrapComponent : 'el-card'" v-bind="form.wrapAttrs"  :key="index")
        template(#header v-if="form.name")
          | {{form.name}}
        common-form(
          ref="form"
          v-bind="form.attrs"
          :type-extends="extendsConfig"
          :options="form.formInfo"
          :values="value"
          )
</template>

<script>


export default {
  name: 'CommonListPage',
  data() {
    return {
      isLoading: false,
      formContainer: {},
      forms: [],
      editConfig: null,
      addConfig: null,
      previewConfig: null,
      submit: null,
      getData: null
    }
  },
  computed: {
    value() {
      return this.$store.state.pageValue
    },
    viewType() {
      return this.$store.state.viewType
    },
    extendsConfig() {
      let configName = this.viewType + 'Config'
      let config = this[configName]
      return config
    }
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    async Submit() {
      let formHasError = false
      let result = {}
      if (Array.isArray(this.$refs.form)) {
        result = this.$refs.form.reduce((finalForm, formData) => {
          let {hasError, form} = formData.getFormData()
          if (hasError) formHasError = hasError
          finalForm = Object.assign(finalForm, form)
          return finalForm
        }, {})
      } else {
        let {hasError, form} = this.$refs.form.getFormData()
        formHasError = hasError
        result = form
      }

      if (this.submit) {
        await this.submit({hasError: formHasError, form: result})
      }
    },
    bindDialogSubmit(Submit) {
      this.submit = Submit
    },
    bindGetData(getData) {
      this.getData = getData
    },
    async GetData() {
      this.isLoading = true
      let {id} = this.$route.query
      if (!id) {
        this.isLoading = false
        return
      }
      if (this.getData) {
        let res = await this.getData(id)
        // console.log(res)
        this.isLoading = false
        this.$store.commit('setDialogValue', res)
      }
      
    },
    init() {
      this.$store.commit('setViewType', this.$route.meta.viewType)
      this.forms = []
      this.editConfig = null
      this.addConfig = null
      this.submit = null
      this.getData = null

      const { formContainer, forms, getData, Submit, editConfig, addConfig } = this.$route.meta.formConfig || {}
      this.formContainer = formContainer || {}
      this.forms = forms || []
      this.editConfig = editConfig || {}
      this.addConfig = addConfig || {}
      this.bindDialogSubmit(Submit)
      this.bindGetData(getData)
      this.GetData()
    }
  },
  mounted  () {
    this.init()
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/style/index.less';

.form {
  margin-bottom: 10px;
}
</style>